import styled from '@pinecast/styles';
import * as React from 'react';

import {ErrorFlag} from './icons';

const ErrorWrap = styled('div', (_, designColors) => ({
  alignItems: 'center',
  color: designColors.contentTextError,
  display: 'flex',
  padding: '4px 0',
}));

/**
 * Marks the element that shows an error, so that a `Form` can find the text of
 * the error that a field describes itself with, and say it after a failed
 * submit (`errorTextOf`, in `forms/focusFirstInvalid.ts`).
 */
export const INLINE_ERROR_SELECTOR = '[data-inline-error]';

const InlineError = ({error, id}: {error: React.ReactNode; id?: string}) => (
  <ErrorWrap data-inline-error="" id={id}>
    <ErrorFlag size={16} style={{marginRight: 4}} />
    {error}
  </ErrorWrap>
);

export default InlineError;
